// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Caml_array from "../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Caml_int32 from "../../../../node_modules/rescript/lib/es6/caml_int32.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Mem$Showside from "../utils/Mem.bs.js";
import * as Pin$Showside from "../types/Pin.bs.js";
import * as UseSafeTimeout from "../../../../node_modules/@makerinc/use-safe-timeout/lib/es6_global/src/UseSafeTimeout.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as Unicons$Showside from "../icons/Unicons.bs.js";
import * as IconHide$Showside from "../icons/IconHide.bs.js";
import * as IconMute$Showside from "../icons/IconMute.bs.js";
import * as PullDown$Showside from "../utils/PullDown.bs.js";
import * as WebShare$Showside from "../utils/WebShare.bs.js";
import * as IconShare$Showside from "../icons/IconShare.bs.js";
import * as IconUnmute$Showside from "../icons/IconUnmute.bs.js";
import * as Scrollable$Showside from "./Scrollable.bs.js";
import * as Slider_Lazy$Showside from "../utils/Slider_Lazy.bs.js";
import * as UseLostWidth$Showside from "../hook/UseLostWidth.bs.js";
import * as ErrorBoundary$Showside from "../utils/ErrorBoundary.bs.js";
import * as ObjectFitMath$Showside from "../utils/ObjectFitMath.bs.js";
import * as QuickViewTabs$Showside from "./QuickViewTabs.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as QuickViewTypes$Showside from "../types/QuickViewTypes.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as IconPIPCollapse$Showside from "../icons/IconPIPCollapse.bs.js";
import * as QuickViewButton$Showside from "./QuickViewButton.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as UseContainerSize$Showside from "../hook/UseContainerSize.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as UseAutoplayProgress$Showside from "../hook/UseAutoplayProgress.bs.js";
import * as UseDisplayVariantBy$Showside from "../hook/UseDisplayVariantBy.bs.js";
import * as QuickViewProductList$Showside from "./QuickViewProductList.bs.js";
import * as RectToRectTransition$Showside from "../utils/RectToRectTransition.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as QuickViewOverlayButton$Showside from "./QuickViewOverlayButton.bs.js";
import * as QuickViewSlideUpDrawer$Showside from "./QuickViewSlideUpDrawer.bs.js";
import * as PictureInPictureContext$Showside from "../utils/PictureInPictureContext.bs.js";
import * as ProductDetailsPage_Lazy$Showside from "../pages/ProductDetailsPage_Lazy.bs.js";
import * as QuickViewCheckoutButton$Showside from "./QuickViewCheckoutButton.bs.js";
import * as QuickViewProductCarousel$Showside from "./QuickViewProductCarousel.bs.js";
import * as QuickViewProductsOverlay$Showside from "./QuickViewProductsOverlay.bs.js";
function QuickViewMediaBox$SlideWrapper(Props) {
  var children = Props.children;
  return children;
}
QuickViewMediaBox$SlideWrapper.displayName = "QuickViewMediaBox.SlideWrapper";
var SlideWrapper = {
  make: QuickViewMediaBox$SlideWrapper
};
function getIndices(num, curIndex) {
  var halfNum = num === 0 ? 0 : num / 2 | 0;
  return Belt_Array.mapWithIndex(Caml_array.make(num, curIndex), function (i, param) {
    return curIndex + (i - halfNum | 0) | 0;
  });
}
var calcFitByDimensions = Mem$Showside.mem(function (originalWidth, originalHeight, containerWidth, windowHeight) {
  var availableSize = {
    width: containerWidth,
    height: windowHeight
  };
  var ratio = originalWidth / originalHeight;
  var height = Math.max(windowHeight, originalHeight);
  var width = height * ratio;
  var mediaSize_width = width | 0;
  var mediaSize = {
    width: mediaSize_width,
    height: height
  };
  var res = ObjectFitMath$Showside.fitAndPosition(availableSize, mediaSize, "scale-down");
  return {
    x: 0,
    y: 0,
    width: res.width,
    height: res.height
  };
});
function QuickViewMediaBox(Props) {
  var viewport = Props.viewport;
  var phase = Props.phase;
  var duration = Props.duration;
  var renderMedia = Props.renderMedia;
  var media = Props.media;
  var config = Props.config;
  var objectFit = Props.objectFit;
  var getSourceVideoTime = Props.getSourceVideoTime;
  var setSourceVideoTime = Props.setSourceVideoTime;
  var layout = Props.layout;
  var columns = Props.columns;
  var onClose = Props.onClose;
  var onInitialMediaReady = Props.onInitialMediaReady;
  var getProductListButtonLabel = Props.getProductListButtonLabel;
  var productListButtonStyle = Props.productListButtonStyle;
  var onClickProductListButton = Props.onClickProductListButton;
  var showMoreProducts = Props.showMoreProducts;
  var displayVariantBy = UseDisplayVariantBy$Showside.useDisplayVariantBy(undefined);
  var match = ConfigurationProvider$Showside.use(undefined);
  var settings = match.config.settings;
  var match$1 = RouterProvider$Showside.useRouter(undefined);
  var goTo = match$1.goTo;
  var route = match$1.route;
  var match$2;
  if (typeof route === "number" || route.TAG !== /* QuickView */3) {
    match$2 = [undefined, undefined];
  } else {
    var match$3 = route._0;
    match$2 = [match$3.productId, match$3.variantId];
  }
  var variantId = match$2[1];
  var productId = match$2[0];
  var match$4 = ViewportContext$Showside.use(undefined);
  var match$5 = match$4.windowSize;
  var windowHeight = match$5.height;
  var windowWidth = match$5.width;
  var isMobile = match$4.isMobile;
  var match$6 = EntrypointContext$Showside.use(undefined);
  var onOpenLink = match$6.onOpenLink;
  var trackEvent = match$6.trackEvent;
  var match$7 = UseSafeTimeout.useSafeTimeout(undefined, undefined);
  var useSlideChangeTimeout = match$7.setTimeout;
  var match$8 = React.useState(function () {
    return QuickViewTypes$Showside.makeMediaChildFromMedia(media);
  });
  var setActiveMediaChild = match$8[1];
  var activeMediaChild = match$8[0];
  var match$9 = React.useState(function () {
    return false;
  });
  var setMuted = match$9[1];
  var muted = match$9[0];
  var match$10 = React.useState(function () {
    return false;
  });
  var setIsProductCarouselOpen = match$10[1];
  var isProductCarouselOpen = match$10[0];
  var match$11 = React.useState(function () {
    return false;
  });
  var openProductLink = settings.openProductLink;
  var openLinkInNewTab = settings.openLinkInNewTab;
  var productCardShape = settings.productCardShape;
  var imageFitToContainer = settings.productCardFitToContainer;
  var setIsTappedToPaused = match$11[1];
  var isTappedToPaused = match$11[0];
  var categoryId = Belt_Option.mapWithDefault(match$1.listPageType, "", function (id) {
    if (typeof id === "number" || id.TAG !== /* Category */0) {
      return "";
    } else {
      return id._0;
    }
  });
  var match$12;
  if (typeof route === "number" || route.TAG !== /* QuickView */3) {
    match$12 = [undefined, undefined, undefined];
  } else {
    var match$13 = route._0;
    match$12 = [match$13.panelClosed, match$13.relatedMediaProductIds, match$13.relatedMediaCategoryId];
  }
  var relatedMediaCategoryId = match$12[2];
  var relatedMediaProductIds = match$12[1];
  var panelClosed = match$12[0];
  var pdpScrollToTop = React.useRef(function (param) {});
  var latch = typeof phase === "number" && phase >= 2 ? panelClosed !== undefined && !panelClosed ? /* Top */0 : /* Bottom */1 : /* OffScreen */2;
  var total = config.media.length;
  var curIndex = Belt_Option.getWithDefault(Belt_Array.getIndexBy(config.media, function (m) {
    return m.id === media.id;
  }), 0);
  var mobileIndices = getIndices(3, curIndex);
  var desktopIndices = getIndices(7, curIndex);
  React.useEffect(function () {
    Curry.app(trackEvent, ["quickview:open", true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
  }, [curIndex]);
  var getMediaForIndex = function (i) {
    var l = config.media.length;
    return Belt_Array.getExn(config.media, Caml_int32.mod_(Caml_int32.mod_(i, l) + l | 0, l));
  };
  var goToProduct = React.useCallback(function (product) {
    return function (variant) {
      if (typeof route === "number") {
        return;
      }
      if (route.TAG !== /* QuickView */3) {
        return;
      }
      var payload = route._0;
      if (openProductLink) {
        return Belt_Option.forEach(product, function (__x) {
          Curry._5(onOpenLink, undefined, undefined, __x, variant, undefined);
        });
      } else {
        return Curry._3(goTo, undefined, undefined, {
          TAG: /* QuickView */3,
          _0: {
            mediaId: payload.mediaId,
            mediaParentId: payload.mediaParentId,
            albumId: payload.albumId,
            productId: Belt_Option.map(product, function (p) {
              return p.id;
            }),
            relatedMediaProductIds: payload.relatedMediaProductIds,
            relatedMediaCategoryId: payload.relatedMediaCategoryId,
            variantId: Belt_Option.map(variant, function (v) {
              return v.id;
            }),
            panelClosed: isMobile ? payload.panelClosed : undefined,
            zoomedPhotoIndex: payload.zoomedPhotoIndex,
            time: payload.time
          }
        });
      }
    };
  }, [RouterProvider$Showside.toString(route)]);
  var goToSlide = function (i) {
    var media = getMediaForIndex(i);
    var match;
    if (productId !== undefined) {
      var nextSlideContainsCurrentProduct = Product$Showside.getProductById(Curry._2(QuickViewTypes$Showside.productsInMedia, config, media), productId) !== undefined;
      if (nextSlideContainsCurrentProduct) {
        match = [productId, variantId];
      } else {
        var productId$1 = Belt_Option.getWithDefault(Belt_Option.map(Belt_Array.get(Curry._2(QuickViewTypes$Showside.productsInMedia, config, media), 0), function (p) {
          return p.id;
        }), productId);
        match = [productId$1, undefined];
      }
    } else {
      match = [undefined, undefined];
    }
    var match$1;
    if (typeof route === "number" || route.TAG !== /* QuickView */3) {
      match$1 = [undefined, undefined, undefined, undefined, undefined];
    } else {
      var match$2 = route._0;
      match$1 = [match$2.time, match$2.zoomedPhotoIndex, match$2.relatedMediaProductIds, match$2.relatedMediaCategoryId, match$2.mediaParentId];
    }
    Curry._3(goTo, undefined, undefined, {
      TAG: /* QuickView */3,
      _0: {
        mediaId: media.id,
        mediaParentId: match$1[4],
        albumId: undefined,
        productId: match[0],
        relatedMediaProductIds: match$1[2],
        relatedMediaCategoryId: match$1[3],
        variantId: match[1],
        panelClosed: panelClosed,
        zoomedPhotoIndex: match$1[1],
        time: match$1[0]
      }
    });
  };
  var sidebarContentMedia = config.isStories ? QuickViewTypes$Showside.makeMediaFromMediaChild(activeMediaChild) : media;
  var productsInMedia = Curry._2(QuickViewTypes$Showside.productsInMedia, config, sidebarContentMedia);
  var isSidebarContentEmpty = productsInMedia.length === 0 && Belt_Option.isNone(sidebarContentMedia.description);
  var isTabsVisible = !config.isStories && config.media.length > 1;
  var isNavigationEnabled = !isMobile && config.media.length > 1;
  var latch$1 = isSidebarContentEmpty ? /* OffScreen */2 : latch;
  var lostWidth = UseLostWidth$Showside.use(!isSidebarContentEmpty);
  var match$14 = UseContainerSize$Showside.use(!isSidebarContentEmpty);
  var containerHeight = match$14[1];
  var containerWidth = match$14[0];
  var handleMuteChange = function (value) {
    Curry._1(setMuted, function (param) {
      return value;
    });
  };
  var shouldAutoplay = React.useMemo(function () {
    var match = config.autoPlay;
    var value;
    var exit = 0;
    if (isMobile && (latch$1 === 0 || productId !== undefined)) {
      value = false;
    } else {
      exit = 1;
    }
    if (exit === 1) {
      value = match ? isMobile || isSidebarContentEmpty ? true : lostWidth === 0 : false;
    }
    var value$1 = value && !isProductCarouselOpen;
    if (value$1) {
      return !isTappedToPaused;
    } else {
      return false;
    }
  }, [config.autoPlay, isMobile, latch$1, lostWidth, productId, isSidebarContentEmpty, isProductCarouselOpen, isTappedToPaused]);
  var match$15 = UseAutoplayProgress$Showside.use(shouldAutoplay, media, undefined, undefined, undefined);
  var setProgressRef = match$15[2];
  var setProgress = match$15[1];
  var progressSpeed = match$15[0];
  var goToNextSlide = function (param) {
    var nextIndex = curIndex + 1 | 0;
    goToSlide(nextIndex < total ? nextIndex : 0);
  };
  var autoplayTimerRef = React.useRef(undefined);
  React.useEffect(function () {
    var $$clearTimeout$1 = function (param) {
      var id = autoplayTimerRef.current;
      if (id !== undefined) {
        clearTimeout(Caml_option.valFromOption(id));
        return;
      }
    };
    if (shouldAutoplay) {
      $$clearTimeout$1(undefined);
      var match = media.kind;
      if (typeof match === "object" || match !== "image") {} else {
        autoplayTimerRef.current = Caml_option.some(setTimeout(goToNextSlide, 5000));
      }
    }
    return function (param) {
      $$clearTimeout$1(undefined);
    };
  }, [categoryId, media.kind, shouldAutoplay]);
  var currentTime = React.useRef(0);
  var match$16 = PictureInPictureContext$Showside.use(undefined);
  var setPictureInPicture = match$16.setMediaId;
  var openPictureInPicture = function (param) {
    if (setPictureInPicture !== undefined) {
      return Curry._5(setPictureInPicture, undefined, currentTime.current, media.originalWidth / media.originalHeight, undefined, categoryId);
    }
  };
  var pictureInPictureButton = setPictureInPicture !== undefined ? React.createElement(QuickViewButton$Showside.make, {
    color: /* Clear */2,
    className: CSS$Showside.prefix(Cn.make(["items-center justify-center leading-none", "pointer-events-auto", "w-13 h-13"])),
    onClick: function (e) {
      e.stopPropagation();
      openPictureInPicture(undefined);
    },
    children: React.createElement(IconPIPCollapse$Showside.make, {
      className: CSS$Showside.prefix("w-8 h-8")
    }),
    block: false,
    flex: true,
    dataTestId: "qv-pip-button"
  }) : null;
  var onClickViewProducts = React.useCallback(function (param) {
    var match;
    if (typeof route === "number" || route.TAG !== /* QuickView */3) {
      match = [undefined, undefined];
    } else {
      var match$1 = route._0;
      match = [match$1.time, match$1.mediaParentId];
    }
    Curry._3(goTo, undefined, undefined, {
      TAG: /* QuickView */3,
      _0: {
        mediaId: categoryId,
        mediaParentId: match[1],
        albumId: undefined,
        productId: productId,
        relatedMediaProductIds: relatedMediaProductIds,
        relatedMediaCategoryId: relatedMediaCategoryId,
        variantId: variantId,
        panelClosed: false,
        zoomedPhotoIndex: undefined,
        time: match[0]
      }
    });
    Curry.app(trackEvent, ["Clicked View Products Button", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
  }, [RouterProvider$Showside.toString(route)]);
  var renderViewProductsButton = function (param) {
    var match = sidebarContentMedia.pins.length;
    var match$1 = sidebarContentMedia.link;
    var kind = isSidebarContentEmpty ? match$1 !== undefined ? (/* LearnMore */{
      _0: match$1
    }) : /* Hidden */5 : match !== 0 ? /* ViewProducts */2 : /* ViewDetails */1;
    if (kind === 5) {
      return null;
    } else {
      return React.createElement(QuickViewOverlayButton$Showside.make, {
        kind: kind,
        at: /* MediaBox */{
          _0: sidebarContentMedia
        },
        color: /* Clear */2,
        openLinkInNewTab: settings.openLinkInNewTab,
        canCollapse: false,
        isMobile: isMobile,
        productsInMedia: productsInMedia,
        onClick: onClickViewProducts
      });
    }
  };
  var renderCheckoutButton = function (colorOpt, param) {
    var color = colorOpt !== undefined ? colorOpt : /* Clear */2;
    var match = settings.checkoutLink;
    var match$1 = Belt_Option.getWithDefault(panelClosed, true);
    var match$2 = Belt_Option.isSome(productId);
    if (match === undefined) {
      return null;
    }
    if (isMobile && !match$1 && !match$2) {
      return null;
    }
    return React.createElement(QuickViewCheckoutButton$Showside.make, {
      color: color
    });
  };
  React.useEffect(function () {
    Curry._1(setActiveMediaChild, function (previous) {
      var previousMediaId = previous.id;
      var match = media.kind;
      if (typeof match !== "object") {
        return QuickViewTypes$Showside.makeMediaChildFromMedia(media);
      }
      var children = match.VAL;
      var child = Belt_Option.orElse(Belt_Array.getBy(children, function (media) {
        return media.id === previousMediaId;
      }), Belt_Array.get(children, 0));
      if (child !== undefined && media.id !== previousMediaId) {
        return child;
      } else {
        return QuickViewTypes$Showside.makeMediaChildFromMedia(media);
      }
    });
  }, [media.id]);
  var match$17 = activeMediaChild.kind;
  var muteUnmuteButton = match$17 === "image" ? null : React.createElement(QuickViewButton$Showside.make, {
    color: /* Clear */2,
    className: CSS$Showside.prefix(Cn.make(["flex items-center justify-center", "w-13 h-13", "pointer-events-auto"])),
    onClick: function (param) {
      Curry._1(setMuted, function (prev) {
        return !prev;
      });
    },
    children: muted ? React.createElement(IconMute$Showside.make, {
      className: CSS$Showside.prefix("w-9.5 h-9.5")
    }) : React.createElement(IconUnmute$Showside.make, {
      className: CSS$Showside.prefix("w-8 h-8")
    }),
    dataTestId: muted ? "qv-button-unmute" : "qv-button-mute"
  });
  var onShare = function (param) {
    var url = window.location.href;
    var text = media.description;
    WebShare$Showside.share(WebShare$Showside.makeShareable(url, text, undefined));
  };
  var shareButton = WebShare$Showside.isSupported(undefined) ? React.createElement(QuickViewButton$Showside.make, {
    color: /* Clear */2,
    className: CSS$Showside.prefix(Cn.make(["flex items-center justify-center", "w-13 h-13", "pointer-events-auto"])),
    onClick: onShare,
    children: React.createElement(IconShare$Showside.make, {
      className: CSS$Showside.prefix("w-8 h-8")
    })
  }) : null;
  var swiping = React.useRef(/* Ended */2);
  var highlightProductRef = React.useRef(function (param) {});
  var slideToProductRef = React.useRef(function (param) {});
  var drawerOffsetControllerRef = React.useRef(function (param) {});
  React.useEffect(function () {
    if (isMobile) {} else {
      Curry._1(highlightProductRef.current, Belt_Array.getBy(config.products, function (product) {
        return Caml_obj.equal(product.id, productId);
      }));
    }
  }, [productId]);
  var loadedRef = React.useRef([]);
  var isLoaded = function (index) {
    return Belt_Array.some(loadedRef.current, function (i) {
      return i === index;
    });
  };
  var setLoaded = function (index) {
    loadedRef.current = Belt_Array.concat(loadedRef.current, [index]);
  };
  React.useEffect(function () {
    Curry._1(setIsTappedToPaused, function (param) {
      return !isLoaded(curIndex);
    });
  }, [curIndex]);
  var calcMarginByBounds = React.useCallback(function (bounds) {
    return Cn.make([CSS$Showside.intToPx(isMobile && bounds.top < 70 ? 70 : 25), "0", "0", "0"]);
  }, [isMobile]);
  var onClickOverlayProduct = React.useCallback(function (product) {
    return function (variant) {
      if (isMobile) {
        return Curry._1(slideToProductRef.current, product);
      } else {
        return Curry._2(goToProduct, product, variant);
      }
    };
  }, [slideToProductRef, goToProduct]);
  var renderSlide = function (media, index, minimal, isPaused) {
    var mediaChild = index === curIndex ? activeMediaChild : QuickViewTypes$Showside.makeMediaChildFromMedia(media);
    var mediaSize = Curry._4(calcFitByDimensions, mediaChild.originalWidth, mediaChild.originalHeight, containerWidth, windowHeight);
    var onReady = function (param) {
      if (param !== undefined) {
        if (param.imageSize.width >= param.width) {
          setLoaded(index);
          if (curIndex === index) {
            Curry._1(setIsTappedToPaused, function (param) {
              return false;
            });
          }
        }
      } else {
        setLoaded(index);
        if (curIndex === index) {
          Curry._1(setIsTappedToPaused, function (param) {
            return false;
          });
        }
      }
      return Curry._1(onInitialMediaReady, param);
    };
    var onTimeChange = function (time, duration) {
      currentTime.current = time;
      Curry._2(setSourceVideoTime, media, time);
      Curry._1(setProgress, Math.round(time / duration * 100) | 0);
    };
    var handleTapToPause = function (pause) {
      if (isLoaded(index)) {
        return Curry._1(setIsTappedToPaused, function (param) {
          return pause;
        });
      }
    };
    var isMediaSelectedInTheSlider = media.id === categoryId;
    var forcePaused = Belt_Option.isSome(productId) && isMobile;
    var isPaused$1 = isPaused || forcePaused;
    var time;
    time = typeof route === "number" || route.TAG !== /* QuickView */3 ? undefined : route._0.time;
    var initialTime = time !== undefined ? time : Curry._1(getSourceVideoTime, media);
    var renderOverlay = function (media) {
      var overlayKind = media.overlayKind;
      var pins = Belt_Array.keepMap(media.pins, function (__x) {
        return Pin$Showside.fromDTO(__x, config.products);
      });
      if (overlayKind !== undefined) {
        if (overlayKind === "image") {
          return React.createElement(QuickViewProductsOverlay$Showside.Hotspots.make, {
            size: /* Lg */1,
            dynamicTooltipWidth: true,
            productCardShape: productCardShape,
            pins: pins,
            width: media.originalWidth,
            height: media.originalHeight,
            fullscreen: true,
            active: !isPaused$1 && phase === /* CompleteFullscreen */2,
            visibility: /* AlwaysShow */1,
            enableButton: false,
            highlightProductRef: highlightProductRef,
            displayVariantBy: displayVariantBy,
            imageFitToContainer: imageFitToContainer,
            openLinkInNewTab: openLinkInNewTab,
            hideOutOfStock: settings.hideOutOfStock,
            onClickPin: onClickOverlayProduct
          });
        } else {
          return React.createElement(QuickViewProductsOverlay$Showside.Stack.make, {
            pins: pins,
            fullscreen: true,
            active: !isPaused$1 && phase === /* CompleteFullscreen */2,
            visibility: /* AlwaysShow */1,
            enableButton: false,
            productCardShape: productCardShape,
            highlightProductRef: highlightProductRef,
            margin: calcMarginByBounds,
            showProductTooltip: !isMobile,
            displayVariantBy: displayVariantBy,
            hideOutOfStock: settings.hideOutOfStock,
            imageFitToContainer: imageFitToContainer,
            openLinkInNewTab: openLinkInNewTab,
            onClickThumbnail: onClickOverlayProduct
          });
        }
      } else {
        return null;
      }
    };
    var renderBackground = function (param) {
      return Curry.app(renderMedia, [config.media, media, index, curIndex, isPaused$1, isMobile, config.isStories, initialTime, onTimeChange, shouldAutoplay, muted, true, goToSlide, onReady, handleMuteChange, handleTapToPause, function (media) {
        Curry._1(setActiveMediaChild, function (param) {
          return media;
        });
      }, renderOverlay, undefined]);
    };
    var largeContainerWidth = config.carousel ? Math.min(containerWidth, mediaSize.width) : containerWidth;
    var largeContainerWidth$1 = isMobile || !config.carousel ? largeContainerWidth : Math.min(largeContainerWidth, (windowWidth - lostWidth | 0) - 130 | 0);
    var largeContainerHeight = isMobile ? mediaSize.height : containerHeight;
    var largeContainer = {
      x: 0,
      y: 0,
      width: largeContainerWidth$1,
      height: largeContainerHeight
    };
    var naturalSize_width = mediaSize.width;
    var naturalSize_height = mediaSize.height;
    var naturalSize = {
      width: naturalSize_width,
      height: naturalSize_height
    };
    var smallContainer = typeof phase === "number" ? undefined : phase._0;
    if (minimal) {
      return React.createElement("div", {
        className: CSS$Showside.prefix(Cn.make(["pointer-events-none relative"])),
        style: {
          height: String(largeContainerHeight) + "px",
          width: String(largeContainerWidth$1) + "px"
        }
      });
    } else {
      var tmp = {
        largeContainer: largeContainer,
        naturalSize: naturalSize,
        smallFitRule: objectFit,
        largeFitRule: "scale-down",
        duration: duration,
        render: function (scale) {
          var match = media.kind;
          return React.createElement(PullDown$Showside.make, {
            onPullDown: onClose,
            children: null,
            scale: 0.25,
            touchNone: false
          }, renderBackground(undefined), React.createElement(ConditionalRender$Showside.When.make, {
            condition: isMediaSelectedInTheSlider,
            children: typeof match === "object" || !(match === "image" || match === "video") ? null : renderOverlay(QuickViewTypes$Showside.makeMediaChildFromMedia(media))
          }));
        }
      };
      if (smallContainer !== undefined) {
        tmp.smallContainer = Caml_option.valFromOption(smallContainer);
      }
      return React.createElement("div", {
        className: isMobile && latch$1 === /* OffScreen */2 ? CSS$Showside.prefix("h-full w-full items-center justify-center flex") : ""
      }, React.createElement("div", {
        className: CSS$Showside.prefix("absolute inset-0"),
        onClick: function (param) {
          if (setPictureInPicture !== undefined) {
            if (isMobile) {
              return;
            } else {
              return openPictureInPicture(undefined);
            }
          } else {
            return Curry._1(onClose, undefined);
          }
        }
      }), React.createElement("div", {
        className: CSS$Showside.prefix(Cn.make(["pointer-events-none relative"])),
        style: {
          height: String(largeContainerHeight) + "px",
          width: String(largeContainerWidth$1) + "px"
        },
        onClick: function (e) {
          var isStackOrPin = Belt_Option.isSome(Caml_option.nullable_to_opt(e.target.closest(".QVTW__pointer-events-auto, .QVTW__pin")));
          var match = swiping.current;
          if (match !== 1 && !isStackOrPin) {
            goToSlide(index);
          }
          swiping.current = /* Ended */2;
        },
        onMouseDown: function (param) {
          swiping.current = /* Started */0;
        },
        onMouseMove: function (param) {
          var match = swiping.current;
          if (match !== 0) {
            return;
          } else {
            swiping.current = /* Swiping */1;
            return;
          }
        }
      }, React.createElement(RectToRectTransition$Showside.make, tmp)));
    }
  };
  var coverflowEffect = React.useMemo(function () {
    return {
      rotate: 0,
      stretch: 110,
      depth: 150,
      modifier: 1.0,
      scale: 0.8,
      slideShadows: false
    };
  }, []);
  var handleSlideChange = React.useCallback(function (e) {
    useSlideChangeTimeout(function (param) {
      var activeIndex = e.activeIndex;
      if (activeIndex !== undefined) {
        return goToSlide(activeIndex);
      }
    }, 16);
  }, [panelClosed, config]);
  var sliderContainerStyle = React.useMemo(function () {
    if (phase === 0) {
      return;
    } else {
      return {
        height: String(windowHeight) + "px",
        left: "0px",
        top: "0px",
        width: String(windowWidth - lostWidth | 0) + "px"
      };
    }
  }, [phase, windowWidth, lostWidth, windowHeight]);
  var handleSliderContainerClick = React.useCallback(function (e) {
    var target = e.target;
    var sliderBackground = Belt_Option.isSome(Caml_option.nullable_to_opt(target.closest(".swiper"))) && Belt_Option.isNone(Caml_option.nullable_to_opt(target.closest(".swiper-button-prev, .swiper-button-next, .swiper-wrapper")));
    if (sliderBackground && setPictureInPicture !== undefined && !isMobile) {
      return openPictureInPicture(undefined);
    }
  }, [isMobile, setPictureInPicture]);
  var slides = React.useMemo(function () {
    return Belt_Array.mapWithIndex(config.media, function (i, media) {
      if (isMobile) {
        if (mobileIndices.includes(i) && media.kind !== "placeholder") {
          return renderSlide(media, i, false, i !== curIndex);
        }
      } else if (desktopIndices.includes(i) && media.kind !== "placeholder") {
        var match = config.carousel;
        return renderSlide(media, i, match || typeof phase === "number" && phase >= 2 ? false : i !== curIndex, i !== curIndex);
      }
      return renderSlide(media, i, true, i !== curIndex);
    });
  }, [curIndex, config.media.length, config.products.length, Belt_Array.reduce(mobileIndices, 0, function (a, b) {
    return a + b | 0;
  }), Belt_Array.reduce(desktopIndices, 0, function (a, b) {
    return a + b | 0;
  }), activeMediaChild.id, containerWidth, containerHeight, panelClosed, muted, duration, phase, objectFit, shouldAutoplay]);
  var renderSlider = function (children) {
    var tmp = {
      className: CSS$Showside.prefix("absolute"),
      onClick: handleSliderContainerClick
    };
    if (sliderContainerStyle !== undefined) {
      tmp.style = Caml_option.valFromOption(sliderContainerStyle);
    }
    var tmp$1 = {
      items: slides,
      initialSlide: curIndex,
      slidesPerView: config.carousel ? /* Auto */0 : (/* Float */{
        _0: 1
      }),
      centeredSlides: true,
      autoHeight: false,
      slideToIndex: curIndex,
      enableKeyboard: true,
      enableNavigation: isNavigationEnabled,
      enablePagination: false,
      className: Cn.make([CSS$Showside.prefix("absolute inset-0"), CSS$Showside.prefix("pointer-events-auto"), "swiper-container swiper-button-clear", phase === /* CompleteFullscreen */2 ? "" : "swiper-pagination-hidden swiper-overflow-visible", !isMobile && phase === /* CompleteFullscreen */2 ? "" : "swiper-button-hidden"]),
      onSlideChange: handleSlideChange,
      threshold: 10.0,
      cssMode: false,
      keepDisabledButtonsVisible: true,
      width: containerWidth,
      coverflowEffect: coverflowEffect,
      dataTestId: "qv-mediabox-slider"
    };
    var tmp$2 = config.carousel ? "coverflow" : undefined;
    if (tmp$2 !== undefined) {
      tmp$1.effect = Caml_option.valFromOption(tmp$2);
    }
    var tmp$3 = config.carousel ? 0 : undefined;
    if (tmp$3 !== undefined) {
      tmp$1.transitionSpeed = tmp$3;
    }
    return React.createElement("div", tmp, React.createElement(Slider_Lazy$Showside.make, tmp$1), children);
  };
  var renderProductList = function (param) {
    var tmp = {
      media: sidebarContentMedia,
      activeMediaChild: activeMediaChild,
      config: config,
      columns: columns,
      onProductSelected: goToProduct
    };
    if (getProductListButtonLabel !== undefined) {
      tmp.getProductListButtonLabel = Caml_option.valFromOption(getProductListButtonLabel);
    }
    if (productListButtonStyle !== undefined) {
      tmp.productListButtonStyle = Caml_option.valFromOption(productListButtonStyle);
    }
    if (onClickProductListButton !== undefined) {
      tmp.onClickProductListButton = Caml_option.valFromOption(onClickProductListButton);
    }
    return React.createElement(ErrorBoundary$Showside.make, {
      componentName: "QuickViewProductList",
      children: React.createElement(QuickViewProductList$Showside.make, tmp)
    });
  };
  var handleCloseButtonClick = function (e) {
    Curry._1(onClose, undefined);
    Curry.app(trackEvent, ["Clicked Media Carousel Close Button", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
  };
  var handleProductClick = React.useCallback(function (product) {
    return function (variant) {
      return Curry._2(goToProduct, product, variant);
    };
  }, [goToProduct]);
  var handleProductHighlight = React.useCallback(function (product) {
    Curry._1(highlightProductRef.current, product);
  }, [highlightProductRef]);
  var handleCarouselChangeVisibility = React.useCallback(function (show) {
    Curry._1(setIsProductCarouselOpen, function (param) {
      return show;
    });
  }, [setIsProductCarouselOpen]);
  var renderDesktop = function (param) {
    var closeButton = React.createElement(QuickViewButton$Showside.make, {
      color: /* Clear */2,
      className: CSS$Showside.prefix(Cn.make(["flex items-center justify-center leading-none", "w-13 h-13", "pointer-events-auto"])),
      onClick: handleCloseButtonClick,
      children: React.createElement(Unicons$Showside.UilTimes.make, {
        size: /* Px */{
          _0: 27
        }
      }),
      dataTestId: "qv-close-button"
    });
    var renderTabs = function (param) {
      var tmp = {
        index: curIndex,
        total: total,
        onClick: goToSlide,
        autoplay: shouldAutoplay,
        autoplayPaused: isTappedToPaused,
        setProgressRef: setProgressRef,
        enableTruncation: true,
        isMobile: isMobile,
        padding: false,
        gradient: false,
        dataTestId: "qv-tabs"
      };
      if (progressSpeed !== undefined) {
        tmp.progressSpeed = progressSpeed;
      }
      return React.createElement(ConditionalRender$Showside.When.make, {
        condition: isTabsVisible,
        children: React.createElement(QuickViewTabs$Showside.make, tmp)
      });
    };
    var isPanelOpened = !Belt_Option.getWithDefault(panelClosed, false) && !isSidebarContentEmpty;
    var renderButtons = function (children) {
      return React.createElement(React.Fragment, undefined, React.createElement("div", {
        className: CSS$Showside.prefix("absolute top-0 left-0 h-48 w-full pointer-events-none"),
        style: {
          background: "linear-gradient(rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0) 60%)"
        }
      }), React.createElement("div", {
        className: CSS$Showside.prefix("absolute flex w-full right-0 top-0 p-2 pointer-events-none")
      }, closeButton, React.createElement("div", {
        className: CSS$Showside.prefix("top-1.5 left-5 mr-10 relative flex-grow h-13 flex items-center")
      }, renderTabs(undefined)), React.createElement("div", {
        className: CSS$Showside.prefix("flex space-x-3")
      }, muteUnmuteButton, pictureInPictureButton, isPanelOpened ? null : renderViewProductsButton(undefined), isPanelOpened ? null : renderCheckoutButton(undefined, undefined))));
    };
    var renderProductDetails = function (param) {
      var tmp = {
        viewport: viewport,
        shouldForceMobile: true,
        isInsideQuickView: true,
        quickViewConfig: config
      };
      if (showMoreProducts !== undefined) {
        tmp.showMoreProducts = showMoreProducts;
      }
      return React.createElement(ConditionalRender$Showside.When.make, {
        condition: productId !== undefined,
        children: React.createElement(ProductDetailsPage_Lazy$Showside.make, tmp)
      });
    };
    var renderPanels = function (fullContent) {
      var renderWrapper = function (width, id, children) {
        return React.createElement("div", {
          className: CSS$Showside.prefix("flex-shrink-0 h-full overflow-hidden bg-main transition-all duration-1000"),
          style: {
            width: CSS$Showside.intToPx(width)
          }
        }, React.createElement("div", {
          className: CSS$Showside.prefix("h-full overflow-hidden relative border-r border-solid border-gray-200"),
          style: {
            width: CSS$Showside.intToPx(width)
          }
        }, React.createElement(Scrollable$Showside.make, {
          restorationId: id,
          scrollToRef: pdpScrollToTop,
          children: children
        })));
      };
      var renderProductListPanel = function (param) {
        return renderWrapper(375, "quickview-panel-1", React.createElement(React.Fragment, undefined, React.createElement(QuickViewButton$Showside.make, {
          className: CSS$Showside.prefix(Cn.make(["inline-block rounded-full bg-main filter brightness-95 p-4 m-4 sticky top-4 z-10"])),
          onClick: function (param) {
            if (typeof route !== "number" && route.TAG === /* QuickView */3) {
              var payload = route._0;
              Curry._3(goTo, undefined, undefined, {
                TAG: /* QuickView */3,
                _0: {
                  mediaId: payload.mediaId,
                  mediaParentId: payload.mediaParentId,
                  albumId: payload.albumId,
                  productId: payload.productId,
                  relatedMediaProductIds: payload.relatedMediaProductIds,
                  relatedMediaCategoryId: payload.relatedMediaCategoryId,
                  variantId: payload.variantId,
                  panelClosed: true,
                  zoomedPhotoIndex: payload.zoomedPhotoIndex,
                  time: payload.time
                }
              });
            }
            Curry.app(trackEvent, ["Clicked Hide Products Button", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
          },
          children: React.createElement(IconHide$Showside.make, {
            className: CSS$Showside.prefix("text-primary w-5 h-5")
          }),
          dataTestId: "qv-collapse-panel-button"
        }), React.createElement(ConditionalRender$Showside.When.make, {
          condition: fullContent,
          children: renderProductList(undefined)
        })));
      };
      var renderProductDetailsPanel = function (param) {
        return renderWrapper(375, "quickview-panel-2", fullContent ? renderProductDetails(undefined) : null);
      };
      var layout$1 = layout ? React.createElement(React.Fragment, undefined, renderProductListPanel(undefined), renderProductDetailsPanel(undefined)) : React.createElement(React.Fragment, undefined, renderProductDetailsPanel(undefined));
      var tx = fullContent ? -lostWidth | 0 : 0;
      var style = {
        transform: CSS$Showside.translate3d(tx, 0, 0)
      };
      return React.createElement("div", {
        className: CSS$Showside.prefix(Cn.make(["absolute top-0 h-full left-full flex flex-row transition-transform duration-250 ease-fastoutslow"])),
        style: style
      }, layout$1);
    };
    var tmp;
    if (typeof phase === "number") {
      switch (phase) {
        case /* Hidden */0:
          tmp = null;
          break;
        case /* MinimalFullscreen */1:
          tmp = React.createElement(React.Fragment, undefined, renderSlider(renderButtons(undefined)), renderPanels(false));
          break;
        case /* CompleteFullscreen */2:
          tmp = React.createElement(React.Fragment, undefined, renderSlider(renderButtons(undefined)), React.createElement("div", {
            className: CSS$Showside.prefix("animate-enter-right-left h-full")
          }, renderPanels(true)));
          break;
      }
    } else {
      tmp = React.createElement(React.Fragment, undefined, renderSlider(renderButtons(undefined)));
    }
    var checkoutButton = renderCheckoutButton(/* Dark */0, undefined);
    return React.createElement("div", {
      className: CSS$Showside.prefix("absolute inset-0")
    }, tmp, isPanelOpened ? React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["absolute right-0 left-0 pointer-events-none top-0 m-2", isPanelOpened ? "opacity-100" : "opacity-0", "flex justify-end"]))
    }, checkoutButton) : null);
  };
  var renderMobile = function (param) {
    var closeButton = React.createElement(QuickViewButton$Showside.make, {
      color: /* Clear */2,
      className: CSS$Showside.prefix(Cn.make(["absolute left-2 flex items-center justify-center leading-none", "w-13 h-13", "pointer-events-auto", isMobile ? "top-8" : "top-2"])),
      onClick: handleCloseButtonClick,
      children: React.createElement(Unicons$Showside.UilTimes.make, {
        size: /* Px */{
          _0: 27
        }
      }),
      dataTestId: "qv-close-button"
    });
    var renderTabs = function (param) {
      var tmp = {
        index: curIndex,
        total: total,
        onClick: goToSlide,
        autoplay: shouldAutoplay,
        autoplayPaused: isTappedToPaused,
        setProgressRef: setProgressRef,
        enableTruncation: true,
        isMobile: isMobile,
        gradient: true,
        dataTestId: "qv-tabs"
      };
      if (progressSpeed !== undefined) {
        tmp.progressSpeed = progressSpeed;
      }
      return React.createElement(ConditionalRender$Showside.When.make, {
        condition: isTabsVisible,
        children: React.createElement(QuickViewTabs$Showside.make, tmp)
      });
    };
    var renderDrawer = function (children) {
      return React.createElement(QuickViewSlideUpDrawer$Showside.make, {
        children: renderProductList(undefined),
        media: activeMediaChild,
        latch: latch$1,
        productsInMedia: productsInMedia,
        offsetControllerRef: drawerOffsetControllerRef,
        renderViewProductsButton: function (param, param$1, param$2) {
          var match = media.kind;
          var progressSpeed$1 = match === "video" ? progressSpeed : undefined;
          var match$1 = media.kind;
          var setProgressRef$1 = match$1 === "video" ? setProgressRef : undefined;
          var tmp = {
            enabled: latch$1 !== /* Top */0,
            media: sidebarContentMedia,
            pins: Belt_Array.keepMap(sidebarContentMedia.pins, function (__x) {
              return Pin$Showside.fromDTO(__x, config.products);
            }),
            showViewAllButton: param,
            flippedExpanded: param$1,
            visualMediaHeight: param$2,
            slideToProductRef: slideToProductRef,
            drawerOffsetControllerRef: drawerOffsetControllerRef,
            children: children,
            onProductHighlight: handleProductHighlight,
            onProductClick: handleProductClick,
            onClickViewProducts: onClickViewProducts,
            onChangeVisibility: handleCarouselChangeVisibility
          };
          if (progressSpeed$1 !== undefined) {
            tmp.progressSpeed = progressSpeed$1;
          }
          if (setProgressRef$1 !== undefined) {
            tmp.setProgressRef = Caml_option.valFromOption(setProgressRef$1);
          }
          return React.createElement(QuickViewProductCarousel$Showside.make, tmp);
        },
        onChangeLatch: function (latch) {
          if (typeof route === "number") {
            return;
          }
          if (route.TAG !== /* QuickView */3) {
            return;
          }
          var payload = route._0;
          var tmp;
          if (typeof latch === "number") {
            switch (latch) {
              case /* Top */0:
                tmp = false;
                break;
              case /* Bottom */1:
              case /* OffScreen */2:
                tmp = undefined;
                break;
            }
          } else {
            tmp = undefined;
          }
          Curry._3(goTo, undefined, undefined, {
            TAG: /* QuickView */3,
            _0: {
              mediaId: categoryId,
              mediaParentId: payload.mediaParentId,
              albumId: undefined,
              productId: productId,
              relatedMediaProductIds: payload.relatedMediaProductIds,
              relatedMediaCategoryId: payload.relatedMediaCategoryId,
              variantId: payload.variantId,
              panelClosed: tmp,
              zoomedPhotoIndex: payload.zoomedPhotoIndex,
              time: payload.time
            }
          });
        }
      });
    };
    return React.createElement("div", {
      className: CSS$Showside.prefix("absolute inset-0 w-full pointer-events-none")
    }, typeof phase === "number" && phase >= 2 ? React.createElement(React.Fragment, undefined, renderSlider(renderTabs(undefined)), closeButton, renderDrawer(latch$1 === /* Top */0 ? null : React.createElement("div", {
      className: CSS$Showside.prefix("flex flex-col space-y-4 items-end flex-grow pr-2 pb-2")
    }, muteUnmuteButton, shareButton, renderCheckoutButton(undefined, undefined)))) : renderSlider(renderDrawer(null)));
  };
  return React.createElement("div", {
    ref: ReactDOMUtils$Showside.Ref.domRef(viewport),
    className: CSS$Showside.prefix(Cn.make(["absolute inset-0", "media_screen"]))
  }, isMobile ? renderMobile(undefined) : renderDesktop(undefined));
}
QuickViewMediaBox.displayName = "QuickViewMediaBox";
var make = QuickViewMediaBox;
export { SlideWrapper, getIndices, calcFitByDimensions, make };
/* calcFitByDimensions Not a pure module */